
import { Component, Vue } from "vue-property-decorator";
import PassengerEdit from "@/components/PassengerEdit.vue";

@Component({
  name: "PassengerEditView",
  components: { PassengerEdit }
})
export default class PassengerEditView extends Vue {
  get passenger(): IPassenger | undefined {
    return this.$store.getters["passenger/passengerById"](this.$route.params.id);
  }

  onClose(result: { saveSuccess: boolean; saveError: boolean }) {
    this.$router.push({
      name: "passengers",
      query: result.saveSuccess ? { saveSuccess: "1" } : undefined,
    });
  }
}
